import React from 'react';

import {DefaultEmptyState} from 'presentation/components/DefaultEmptyState';
import {translations} from 'presentation/translations-new';
import {AuthorizationsEmptyStateProps} from './types';

const {noFilteredResults} = translations['pt-br'].commons;

function AuthorizationsEmptyState({
	description,
	internalPadding,
	title = noFilteredResults,
	dataTagId,
	clearFilter,
}: AuthorizationsEmptyStateProps) {
	return (
		<DefaultEmptyState
			title={title}
			description={description}
			internalPadding={internalPadding}
			dataTagId={dataTagId}
			clearFilters={clearFilter}
		/>
	);
}

export {AuthorizationsEmptyState};
